const INTERNAL_EMAIL_DOMAIN = "@heyacto.com";

/** Whether this email belongs to Acto rather than a customer: any @heyacto.com address. */
export function isInternalUser(email: string | undefined): boolean {
  return Boolean(email?.trim().toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN));
}
